package com.flowyride.core.api

import com.flowyride.core.domain.account.AccountException
import com.flowyride.core.domain.account.AccountStatus
import com.flowyride.core.domain.account.ManagedUser
import com.flowyride.core.domain.account.RegistrationRequest
import com.flowyride.core.domain.account.User
import com.flowyride.core.domain.account.UserRole

fun User.toDto() = UserDto(id, username, email, role.toDto(), status.toDto())

fun UserDto.toDomain() = User(id, username, email, role.toDomain(), status.toDomain())

fun ManagedUser.toDto() = ManagedUserDto(user.toDto(), requestMessage, createdAtEpochMillis)

fun ManagedUserDto.toDomain() = ManagedUser(user.toDomain(), requestMessage, createdAtEpochMillis)

fun RegistrationRequest.toDto() = RegisterRequestDto(username, email, password, message)

fun RegisterRequestDto.toDomain() = RegistrationRequest(username.trim(), email.trim(), password, message?.trim()?.ifBlank { null })

fun UserRole.toDto() = when (this) {
    UserRole.USER -> RoleDto.USER
    UserRole.ADMIN -> RoleDto.ADMIN
}

fun RoleDto.toDomain() = when (this) {
    RoleDto.USER -> UserRole.USER
    RoleDto.ADMIN -> UserRole.ADMIN
}

fun AccountStatus.toDto() = AccountStatusDto.valueOf(name)

fun AccountStatusDto.toDomain() = AccountStatus.valueOf(name)

fun ApiErrorDto.toAccountException(): AccountException = when (code) {
    ApiErrorCode.INVALID_CREDENTIALS, ApiErrorCode.UNAUTHORIZED -> AccountException.InvalidCredentials()
    ApiErrorCode.ACCOUNT_PENDING -> AccountException.Pending()
    ApiErrorCode.ACCOUNT_REFUSED -> AccountException.Refused()
    ApiErrorCode.USERNAME_TAKEN -> AccountException.UsernameTaken()
    ApiErrorCode.EMAIL_TAKEN -> AccountException.EmailTaken()
    ApiErrorCode.RATE_LIMITED -> AccountException.TooManyAttempts()
    else -> AccountException.Invalid(message)
}
